import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  IconButton,
  TextField,
  MenuItem,
  Button,
  InputAdornment,
  Modal,
  Autocomplete,
  Divider,
} from "@mui/material";
import { Delete, Search, Add, ReceiptLong, Print } from "@mui/icons-material";
import axios from "axios";
import apiEndpoints from "../../apiconfig";

const Payments = () => {
  const [payments, setPayments] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);

  const [search, setSearch] = useState("");
  const [modeFilter, setModeFilter] = useState("");
  const [typeFilter, setTypeFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [feeRequests, setFeeRequests] = useState([]);

  const [openAdd, setOpenAdd] = useState(false);
  const [openReceipt, setOpenReceipt] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [studentDetails, setStudentDetails] = useState(null);
  const [errors, setErrors] = useState({});
  const token = localStorage.getItem("token");

  const numberToWords = (num) => {
    const a = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    const g = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];
    
    const parseBasic = (n) => {
      let str = '';
      if (n >= 100) {
        str += a[Math.floor(n / 100)] + ' Hundred ';
        n %= 100;
      }
      if (n >= 20) {
        str += b[Math.floor(n / 10)] + ' ';
        n %= 10;
      }
      if (n > 0) {
        str += a[n] + ' ';
      }
      return str.trim();
    };

    if (num === 0) return 'Zero';
    
    let result = '';
    let parts = [];
    
    while (num > 0) {
      parts.push(num % 1000);
      num = Math.floor(num / 1000);
    }
    
    for (let i = 0; i < parts.length; i++) {
      if (parts[i] === 0) continue;
      let words = parseBasic(parts[i]);
      result = words + ' ' + g[i] + ' ' + result;
    }
    
    return result.trim() + ' Only';
  };

  const formatClassName = (name) => {
    if (!name) return 'N/A';
    const isGuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(name) || /^[0-9a-f]{32}$/i.test(name);
    return isGuid ? 'N/A' : name;
  };

  const handlePrint = (payment, studentDetails) => {
    const printWindow = window.open("", "_blank", "width=850,height=700");
    const loggedInUser = JSON.parse(localStorage.getItem("user") || "{}");
    const schoolLogo = window.location.origin + '/schoollogo.png';
    const orgName = loggedInUser.organization_name || "ROOTS MONTESSORI SCHOOL";
    
    const addressStr = [
      loggedInUser.address,
      loggedInUser.city,
      loggedInUser.state,
      loggedInUser.country,
      loggedInUser.pincode ? `PIN: ${loggedInUser.pincode}` : ""
    ].filter(Boolean).join(", ") || "12, Green Street, Bangalore, Karnataka 560102";
    
    const contactStr = [
      loggedInUser.phone ? `Phone: ${loggedInUser.phone}` : "",
      loggedInUser.email ? `Email: ${loggedInUser.email}` : ""
    ].filter(Boolean).join(" | ") || "Phone No. : 080-2223344 | Email: info@rootsmontessori.com";

    const formattedDate = payment.payment_date ? new Date(payment.payment_date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    }).replace(/\//g, '-') : "";

    const pDate = payment.payment_date ? new Date(payment.payment_date) : new Date();
    const year = pDate.getFullYear();
    const month = pDate.getMonth();
    const acadYear = month >= 5 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
    const amountVal = Number(payment.amount) || 0;
    const classNameVal = formatClassName(studentDetails ? studentDetails.class_name : (payment.class_name || payment.class));
    const classAndSection = classNameVal;

    const studentName = studentDetails 
      ? `${studentDetails.first_name || ""} ${studentDetails.last_name || ""}`.trim() 
      : `${payment.first_name || ""} ${payment.last_name || ""}`.trim();
    const fatherName = studentDetails 
      ? `${studentDetails.parent_first || ""} ${studentDetails.parent_last || ""}`.trim() 
      : (payment.parent_name || 'N/A');
    const motherName = studentDetails 
      ? `${studentDetails.mother_first_name || ""} ${studentDetails.mother_last_name || ""}`.trim() 
      : (payment.mother_name || 'N/A');
    const admissionNo = studentDetails 
      ? studentDetails.admission_number 
      : (payment.admission_number || 'N/A');
    const fatherMobile = studentDetails 
      ? studentDetails.parent_mobile 
      : (payment.parent_phone || 'N/A');

    printWindow.document.write(`
      <html>
        <head>
          <title>Receipt - ${payment.transcation_id || payment.id}</title>
          <style>
            body {
              font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
              color: #2d3748;
              padding: 20px;
              line-height: 1.4;
              font-size: 13px;
            }
            .receipt-border {
              border: 2px solid #3F51B5;
              border-top: 8px solid #3F51B5;
              border-radius: 6px;
              padding: 20px;
              max-width: 800px;
              margin: 0 auto;
              box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
            }
            .header-table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 15px;
            }
            .logo-cell {
              width: 80px;
              vertical-align: middle;
              text-align: left;
            }
            .logo-img {
              width: 70px;
              height: 70px;
              border-radius: 50%;
              object-fit: cover;
              border: 2px solid #3F51B5;
            }
            .school-details-cell {
              text-align: center;
              vertical-align: middle;
              padding-right: 70px;
            }
            .school-name {
              font-size: 24px;
              color: #3F51B5;
              font-weight: bold;
              margin: 0;
              letter-spacing: 0.5px;
            }
            .school-address {
              font-size: 11px;
              color: #718096;
              margin: 5px 0 0 0;
              font-weight: 500;
            }
            .receipt-title-box {
              background-color: #3F51B5;
              color: #ffffff;
              text-align: center;
              padding: 8px 0;
              font-weight: bold;
              font-size: 14px;
              text-transform: uppercase;
              margin-bottom: 20px;
              border-radius: 4px;
            }
            .info-table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 20px;
            }
            .info-table td {
              width: 50%;
              padding: 0 10px;
              vertical-align: top;
            }
            .details-card {
              background: #f8fafc;
              border: 1px solid #edf2f7;
              border-radius: 6px;
              padding: 12px;
            }
            .inner-info-table {
              width: 100%;
              border-collapse: collapse;
            }
            .inner-info-table td {
              padding: 6px 0;
              font-size: 12px;
              border-bottom: 1px dashed #e2e8f0;
            }
            .inner-info-table tr:last-child td {
              border-bottom: none;
            }
            .label-col {
              font-weight: 500;
              color: #718096;
              width: 45%;
            }
            .value-col {
              font-weight: bold;
              color: #1a202c;
              text-align: right;
            }
            .particulars-table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 0px;
              border-radius: 6px;
              overflow: hidden;
              border: 1px solid #e2e8f0;
            }
            .particulars-table th {
              background-color: #3F51B5;
              color: #ffffff;
              padding: 8px 12px;
              font-weight: bold;
              text-align: left;
              font-size: 12px;
            }
            .particulars-table td {
              padding: 12px;
              height: 80px;
              vertical-align: top;
              border-bottom: 1px solid #e2e8f0;
              color: #2d3748;
            }
            .total-words-box {
              display: table;
              width: 100%;
              border: 1px solid #3F51B5;
              background-color: #f0f2fa;
              margin-bottom: 20px;
              border-radius: 4px;
              overflow: hidden;
            }
            .words-cell {
              display: table-cell;
              padding: 10px 12px;
              font-weight: bold;
              font-size: 12px;
              color: #3F51B5;
              vertical-align: middle;
            }
            .amount-cell {
              display: table-cell;
              width: 120px;
              background-color: #3F51B5;
              color: #ffffff;
              padding: 10px 12px;
              font-weight: bold;
              text-align: right;
              font-size: 14px;
              vertical-align: middle;
            }
            .note-box {
              font-size: 10px;
              line-height: 1.4;
              margin-top: 15px;
              color: #718096;
            }
            .note-title {
              font-weight: bold;
              margin-bottom: 5px;
              color: #4a5568;
            }
            .note-item {
              margin-bottom: 3px;
            }
            .align-right {
              text-align: right;
            }
            @media print {
              body {
                padding: 0;
              }
              .receipt-border {
                box-shadow: none;
                border: 2px solid #3F51B5 !important;
                border-top: 8px solid #3F51B5 !important;
              }
            }
          </style>
        </head>
        <body>
          <div class="receipt-border">
            <table class="header-table">
              <tr>
                <td class="logo-cell">
                  <img src="${schoolLogo}" class="logo-img" alt="Logo" onerror="this.style.display='none'">
                </td>
                <td class="school-details-cell">
                  <h1 class="school-name">${orgName.toUpperCase()}</h1>
                  <p class="school-address">
                    ${addressStr}<br>
                    ${contactStr}
                  </p>
                </td>
              </tr>
            </table>

            <div class="receipt-title-box">
              ONLINE FEE RECEIPT FOR THE ACADEMIC YEAR : ${acadYear}
            </div>

            <table class="info-table">
              <tr>
                <td>
                  <div class="details-card">
                    <table class="inner-info-table">
                      <tr>
                        <td class="label-col">Student Name</td>
                        <td class="value-col">${studentName.toUpperCase()}</td>
                      </tr>
                      <tr>
                        <td class="label-col">Payment Date</td>
                        <td class="value-col">${formattedDate}</td>
                      </tr>
                      <tr>
                        <td class="label-col">Fathers name</td>
                        <td class="value-col">${fatherName.toUpperCase()}</td>
                      </tr>
                      <tr>
                        <td class="label-col">Mothers name</td>
                        <td class="value-col">${motherName.toUpperCase()}</td>
                      </tr>
                    </table>
                  </div>
                </td>
                <td>
                  <div class="details-card">
                    <table class="inner-info-table">
                      <tr>
                        <td class="label-col">Admission No</td>
                        <td class="value-col">${admissionNo.toUpperCase()}</td>
                      </tr>
                      <tr>
                        <td class="label-col">Receipt No</td>
                        <td class="value-col">${payment.transcation_id || payment.id}</td>
                      </tr>
                      <tr>
                        <td class="label-col">Class and Section</td>
                        <td class="value-col">${classAndSection.toUpperCase()}</td>
                      </tr>
                      <tr>
                        <td class="label-col">Father's Mobile No</td>
                        <td class="value-col">${fatherMobile}</td>
                      </tr>
                    </table>
                  </div>
                </td>
              </tr>
            </table>

            <table class="particulars-table">
              <thead>
                <tr>
                  <th style="border-right: 1px solid rgba(255,255,255,0.2);">Particulars</th>
                  <th class="align-right" style="width: 120px; border-right: 1px solid rgba(255,255,255,0.2);">Due (Rs)</th>
                  <th class="align-right" style="width: 120px;">Paid (Rs)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="border-right: 1px solid #e2e8f0;">${payment.fee_name || 'School Fee'}</td>
                  <td class="align-right" style="border-right: 1px solid #e2e8f0;">${amountVal.toFixed(2)}</td>
                  <td class="align-right" style="font-weight: bold;">${amountVal.toFixed(2)}</td>
                </tr>
              </tbody>
            </table>

            <div class="total-words-box">
              <div class="words-cell">Total Amount in Words : [ Rupees ${numberToWords(amountVal)} ]</div>
              <div class="amount-cell">Rs.${amountVal.toFixed(2)}</div>
            </div>

            <div class="note-box">
              <div class="note-title">NOTE:</div>
              <div class="note-item">1.This is a Computer Generated Fee Payment Receipt, 'No Signature' is required.</div>
              <div class="note-item">2.Parents are advised to keep the receipt securely as it cannot be issued by School,if misplaced.</div>
              <div class="note-item">3.The fees is subject to Revision as and when advised by the Concerned Authorities and is payable by Parent. The Revision of fees will be notified.</div>
              <div class="note-item">4.Admission Fee is not Refundable.</div>
            </div>
          </div>
          <script>
            window.onload = function() {
              window.print();
              setTimeout(function() { window.close(); }, 500);
            };
          </` + `script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

    const axiosAuth = axios.create({
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        }
    });

  useEffect(() => {
    const fetchStudentDetails = async () => {
      if (selectedPayment && (selectedPayment.student_guid || selectedPayment.student_id)) {
        try {
          const guid = selectedPayment.student_guid || selectedPayment.student_id;
          const res = await axiosAuth.get(`${apiEndpoints.student}?guid=${guid}`);
          if (res.data && res.data.status === "success") {
            setStudentDetails(res.data.data);
          } else {
            setStudentDetails(null);
          }
        } catch (error) {
          console.error("Error fetching student details:", error);
          setStudentDetails(null);
        }
      } else {
        setStudentDetails(null);
      }
    };
    fetchStudentDetails();
  }, [selectedPayment]);

  const [form, setForm] = useState({
    transcation_id: "",
    student_guid: "",
    request_id: "",
    amount: "",
    type: "manual",
    mode: "cash",
    payment_date: "",
    payment_status: "success",
  });

  const [selectedRequest, setSelectedRequest] = useState(null);

  const handleFormChange = (key, value) => {
    setForm({ ...form, [key]: value });
    setErrors({ ...errors, [key]: "" });
  };

  // Load all fee requests for dropdown
  const loadFeeRequests = async () => {
    const res = await axiosAuth.get(
      `${apiEndpoints.transactions}?action=get_fee_requests`
    );
    setFeeRequests(res.data?.data || []);
  };

  // Load all payments
  const loadPayments = async () => {
    const res = await axiosAuth.get(
      `${apiEndpoints.transactions}?action=get&page=${page}&from=${from}&to=${to}&mode=${modeFilter}&type=${typeFilter}&status=${statusFilter}`
    );

    setPayments(res.data.data.data);
    setPages(res.data.data.pages);
  };

  useEffect(() => {
    loadPayments();
  }, [page, from, to, modeFilter, typeFilter, statusFilter]);

  const deletePayment = async (id) => {
    await axiosAuth.post(`${apiEndpoints.transactions}?action=delete`, { id });
    loadPayments();
  };

  const savePayment = async () => {
    const newErrors = {};

    if (!form.request_id) newErrors.request_id = "Select a request";
    if (!form.student_guid) newErrors.student_guid = "Student not recognized";
    if (!form.amount || form.amount <= 0)
      newErrors.amount = "Amount must be valid";
    if (!form.payment_date) newErrors.payment_date = "Select payment date";

    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
      return;
    }

    await axiosAuth.post(`${apiEndpoints.transactions}?action=add`, form);

    setOpenAdd(false);
    loadPayments();

    setForm({
      transcation_id: "",
      student_guid: "",
      request_id: "",
      amount: "",
      type: "manual",
      mode: "cash",
      payment_date: "",
      payment_status: "success",
    });

    setSelectedRequest(null);
  };

  const handleRequestChange = (e, value) => {
    if (!value) {
      setSelectedRequest(null);
      setForm({
        ...form,
        request_id: "",
        student_guid: "",
        amount: "",
      });
      return;
    }

    setSelectedRequest(value);
    setForm({
      ...form,
      request_id: value.request_id,
      student_guid: value.student_guid,
      amount: value.fee_amount,
    });
  };

  const statusColor = (s) =>
    s === "success" ? "success" : s === "failed" ? "error" : "warning";

  return (
    <Box sx={{ p: 2 }}>
      {/* HEADER */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          alignItems: "center",
          mb: 2,
          gap: 2,
        }}
      >
        <Typography variant="h6" fontWeight={700}>
          Transactions
        </Typography>

        <Button
          variant="contained"
          startIcon={<Add />}
          sx={{ borderRadius: 3, px: 3 }}
          onClick={() => {
            loadFeeRequests();
            setOpenAdd(true);
          }}
        >
          Add Transaction
        </Button>
      </Box>

      {/* FILTERS */}
      <Paper
        sx={{
          p: 2,
          mb: 3,
          borderRadius: 3,
          background: "rgba(255,255,255,0.5)",
          backdropFilter: "blur(12px)",
          border: "1px solid rgba(255,255,255,0.5)",
          boxShadow: "0 10px 24px rgba(15, 23, 42, 0.12)",
        }}
      >
        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
          <TextField
            type="date"
            label="From"
            size="small"
            InputLabelProps={{ shrink: true }}
            InputProps={{ sx: { borderRadius: 3 } }}
            value={from}
            onChange={(e) => setFrom(e.target.value)}
            sx={{ minWidth: 160, width: { xs: "100%", md: 160 } }}
          />

          <TextField
            type="date"
            label="To"
            size="small"
            InputLabelProps={{ shrink: true }}
            value={to}
            onChange={(e) => setTo(e.target.value)}
            sx={{ minWidth: 160, width: { xs: "100%", md: 160 } }}
            InputProps={{ sx: { borderRadius: 3 } }}
          />

          <TextField
            select
            label="Mode"
            size="small"
            value={modeFilter}
            onChange={(e) => setModeFilter(e.target.value)}
            sx={{ minWidth: 140, width: { xs: "100%", md: 160 } }}
            InputProps={{ sx: { borderRadius: 3 } }}
          >
            <MenuItem value="">All</MenuItem>
            <MenuItem value="cash">Cash</MenuItem>
            <MenuItem value="card">Card</MenuItem>
            <MenuItem value="upi">UPI</MenuItem>
          </TextField>

          <TextField
            select
            label="Type"
            size="small"
            value={typeFilter}
            onChange={(e) => setTypeFilter(e.target.value)}
            sx={{ minWidth: 140, width: { xs: "100%", md: 140 } }}
            InputProps={{ sx: { borderRadius: 3 } }}
          >
            <MenuItem value="">All</MenuItem>
            <MenuItem value="manual">Manual</MenuItem>
            <MenuItem value="gateway">Gateway</MenuItem>
          </TextField>

          <TextField
            select
            label="Status"
            size="small"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            sx={{ minWidth: 140, width: { xs: "100%", md: 140 } }}
            InputProps={{ sx: { borderRadius: 3 } }}
          >
            <MenuItem value="">All</MenuItem>
            <MenuItem value="success">Success</MenuItem>
            <MenuItem value="failed">Failed</MenuItem>
            <MenuItem value="pending">Pending</MenuItem>
          </TextField>

          <TextField
            placeholder="Search student..."
            size="small"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            sx={{
              minWidth: { md: 200, lg: 220 },
              width: { xs: "100%", md: 200 },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
              sx: { borderRadius: 3 },
            }}
          />
        </Box>
      </Paper>

      {/* TABLE */}
      <Paper
        sx={{
          borderRadius: 3,
          overflow: "hidden",
          background: "rgba(255,255,255,0.5)",
          backdropFilter: "blur(12px)",
          border: "1px solid rgba(255,255,255,0.5)",
          boxShadow: "0 10px 24px rgba(15, 23, 42, 0.12)",
        }}
      >
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ background: "rgba(0,0,0,0.04)" }}>
                <TableCell>ID</TableCell>
                <TableCell>Txn ID</TableCell>
                <TableCell>Student</TableCell>
                <TableCell>Request</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Mode</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Status</TableCell>
                <TableCell align="center">Receipt</TableCell>
                <TableCell align="center">Delete</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {payments.map((p) => (
                <TableRow key={p.id} hover>
                  <TableCell>{p.id}</TableCell>
                  <TableCell>{p.transcation_id || p.id}</TableCell>
                  <TableCell>
                    {p.first_name} {p.last_name}
                  </TableCell>
                  <TableCell>{p.request_id}</TableCell>
                  <TableCell>{p.payment_date}</TableCell>
                  <TableCell>{p.mode}</TableCell>
                  <TableCell>₹{p.amount}</TableCell>
                  <TableCell>
                    <Chip
                      label={p.payment_status}
                      color={statusColor(p.payment_status)}
                      size="small"
                    />
                  </TableCell>

                  <TableCell align="center">
                    {p.payment_status === "success" && (
                      <IconButton
                        color="primary"
                        onClick={() => {
                          setSelectedPayment(p);
                          setOpenReceipt(true);
                        }}
                        title="View Receipt"
                      >
                        <ReceiptLong />
                      </IconButton>
                    )}
                  </TableCell>

                  <TableCell align="center">
                    <IconButton
                      color="error"
                      onClick={() => deletePayment(p.id)}
                    >
                      <Delete />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {/* PAGINATION */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: 3, gap: 2 }}>
        <Button disabled={page === 1} onClick={() => setPage(page - 1)}>
          Prev
        </Button>

        <Typography>
          Page {page} / {pages}
        </Typography>

        <Button disabled={page === pages} onClick={() => setPage(page + 1)}>
          Next
        </Button>
      </Box>

      {/* ADD TRANSACTION MODAL */}
      <Modal
        open={openAdd}
        onClose={() => {
          setOpenAdd(false);
          setSelectedRequest(null);
          setErrors({});
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "90%", sm: 420 },
            bgcolor: "white",
            p: 3,
            borderRadius: 3,
            boxShadow: 5,
          }}
        >
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 700 }}>
            Add Transaction
          </Typography>

          {/* Transaction ID */}
          <TextField
            fullWidth
            label="Transaction ID"
            size="small"
            sx={{ mb: 2 }}
            value={form.transcation_id}
            onChange={(e) => handleFormChange("transcation_id", e.target.value)}
            InputProps={{ sx: { borderRadius: 3 } }}
          />

          {/* Request selection */}
          <Autocomplete
            options={feeRequests}
            value={selectedRequest}
            getOptionLabel={(option) => option?.display_text || ""}
            isOptionEqualToValue={(option, value) =>
              option.request_id === value.request_id
            }
            onChange={handleRequestChange}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Request"
                size="small"
                sx={{ mb: 2 ,borderRadius:3}}
                error={Boolean(errors.request_id)}
                helperText={errors.request_id}
                
              />
            )}
          />

          {/* Amount */}
          <TextField
            fullWidth
            label="Amount"
            size="small"
            type="number"
            sx={{ mb: 2 }}
            value={form.amount}
            error={Boolean(errors.amount)}
            helperText={errors.amount}
            onChange={(e) => handleFormChange("amount", e.target.value)}
            InputProps={{ sx: { borderRadius: 3 } }}
          />

          {/* Type */}
          <TextField
            select
            fullWidth
            label="Type"
            size="small"
            sx={{ mb: 2 }}
            value={form.type}
            onChange={(e) => handleFormChange("type", e.target.value)}
            InputProps={{ sx: { borderRadius: 3 } }}
          >
            <MenuItem value="manual">Manual</MenuItem>
            <MenuItem value="gateway">Gateway</MenuItem>
          </TextField>

          {/* Mode */}
          <TextField
            select
            fullWidth
            label="Mode"
            size="small"
            sx={{ mb: 2 }}
            value={form.mode}
            onChange={(e) => handleFormChange("mode", e.target.value)}
            InputProps={{ sx: { borderRadius: 3 } }}
          >
            <MenuItem value="cash">Cash</MenuItem>
            <MenuItem value="card">Card</MenuItem>
            <MenuItem value="upi">UPI</MenuItem>
          </TextField>

          {/* Payment date */}
          <TextField
            type="date"
            fullWidth
            label="Payment Date"
            size="small"
            sx={{ mb: 2 }}
            InputLabelProps={{ shrink: true }}
            value={form.payment_date}
            error={Boolean(errors.payment_date)}
            helperText={errors.payment_date}
            onChange={(e) => handleFormChange("payment_date", e.target.value)}
            InputProps={{ sx: { borderRadius: 3 } }}
          />

          {/* Status */}
          <TextField
            select
            fullWidth
            label="Status"
            size="small"
            sx={{ mb: 2 }}
            value={form.payment_status}
            onChange={(e) => handleFormChange("payment_status", e.target.value)}
            InputProps={{ sx: { borderRadius: 3 } }}
          >
            <MenuItem value="success">Success</MenuItem>
            <MenuItem value="failed">Failed</MenuItem>
            <MenuItem value="pending">Pending</MenuItem>
          </TextField>

          <Button
            variant="contained"
            fullWidth
            onClick={savePayment}
            sx={{ borderRadius: 999, px: 3 }}
          >
            Save Transaction
          </Button>
        </Box>
      </Modal>

      {/* RECEIPT PREVIEW MODAL */}
      <Modal
        open={openReceipt}
        onClose={() => {
          setOpenReceipt(false);
          setSelectedPayment(null);
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "95%", sm: 700 },
            maxHeight: "90vh",
            overflowY: "auto",
            bgcolor: "white",
            p: { xs: 2, sm: 4 },
            borderRadius: 3,
            boxShadow: 24,
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography variant="h6" fontWeight={700} color="primary">
              Fee E-Receipt Preview
            </Typography>
            <Chip label="PAID" color="success" variant="outlined" size="small" />
          </Box>
          <Divider />          {selectedPayment && (() => {
            const loggedInUser = JSON.parse(localStorage.getItem("user") || "{}");
            const schoolLogo = window.location.origin + '/schoollogo.png';
            const orgName = loggedInUser.organization_name || "ROOTS MONTESSORI SCHOOL";
            
            const addressStr = [
              loggedInUser.address,
              loggedInUser.city,
              loggedInUser.state,
              loggedInUser.country,
              loggedInUser.pincode ? `PIN: ${loggedInUser.pincode}` : ""
            ].filter(Boolean).join(", ") || "12, Green Street, Bangalore, Karnataka 560102";
            
            const contactStr = [
              loggedInUser.phone ? `Phone: ${loggedInUser.phone}` : "",
              loggedInUser.email ? `Email: ${loggedInUser.email}` : ""
            ].filter(Boolean).join(" | ") || "Phone No. : 080-2223344 | Email: info@rootsmontessori.com";

            const pDate = selectedPayment.payment_date ? new Date(selectedPayment.payment_date) : new Date();
            const acadYear = pDate.getMonth() >= 5 ? `${pDate.getFullYear()}-${pDate.getFullYear() + 1}` : `${pDate.getFullYear() - 1}-${pDate.getFullYear()}`;
            const amountVal = Number(selectedPayment.amount) || 0;
            const formattedDate = selectedPayment.payment_date ? new Date(selectedPayment.payment_date).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric"
            }).replace(/\//g, '-') : "";
            const classNameVal = formatClassName(studentDetails ? studentDetails.class_name : (selectedPayment.class_name || selectedPayment.class));

            const studentName = studentDetails 
              ? `${studentDetails.first_name || ""} ${studentDetails.last_name || ""}`.trim() 
              : `${selectedPayment.first_name || ""} ${selectedPayment.last_name || ""}`.trim();
            const fatherName = studentDetails 
              ? `${studentDetails.parent_first || ""} ${studentDetails.parent_last || ""}`.trim() 
              : (selectedPayment.parent_name || 'N/A');
            const motherName = studentDetails 
              ? `${studentDetails.mother_first_name || ""} ${studentDetails.mother_last_name || ""}`.trim() 
              : (selectedPayment.mother_name || 'N/A');
            const admissionNo = studentDetails 
              ? studentDetails.admission_number 
              : (selectedPayment.admission_number || 'N/A');
            const fatherMobile = studentDetails 
              ? studentDetails.parent_mobile 
              : (selectedPayment.parent_phone || 'N/A');

            return (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                {/* E-Receipt Border Wrapper to match print layout */}
                <Box
                  sx={{
                    border: "2px solid #3F51B5",
                    borderTop: "8px solid #3F51B5",
                    borderRadius: 2,
                    p: 2.5,
                    fontFamily: "'Montserrat', sans-serif",
                    color: "#2d3748",
                    display: "flex",
                    flexDirection: "column",
                    gap: 2.5,
                    boxShadow: "0 4px 12px rgba(63, 81, 181, 0.08)"
                  }}
                >
                  {/* Header Row */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Box
                      component="img"
                      src={schoolLogo}
                      alt="Logo"
                      onError={(e) => { e.target.style.display = 'none'; }}
                      sx={{ width: 65, height: 65, borderRadius: "50%", objectFit: "cover", border: "2px solid #3F51B5" }}
                    />
                    <Box sx={{ textAlign: "center", flexGrow: 1, pr: 8 }}>
                      <Typography variant="subtitle1" fontWeight="bold" sx={{ fontSize: "18px", m: 0, color: "#3F51B5", letterSpacing: "0.5px" }}>
                        {orgName.toUpperCase()}
                      </Typography>
                      <Typography variant="caption" sx={{ fontSize: "10px", fontWeight: 500, color: "#718096", display: "block", mt: 0.5 }}>
                        {addressStr}
                      </Typography>
                      <Typography variant="caption" sx={{ fontSize: "10px", fontWeight: 500, color: "#718096", display: "block" }}>
                        {contactStr}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Title Banner */}
                  <Box
                    sx={{
                      backgroundColor: "#3F51B5",
                      color: "#ffffff",
                      textAlign: "center",
                      py: 1,
                      fontWeight: "bold",
                      fontSize: "12px",
                      textTransform: "uppercase",
                      borderRadius: 1,
                      boxShadow: "0 2px 4px rgba(63, 81, 181, 0.15)"
                    }}
                  >
                    ONLINE FEE RECEIPT FOR THE ACADEMIC YEAR : {acadYear}
                  </Box>

                  {/* Student Details Grid */}
                  <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: 2, fontSize: "12px" }}>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.8, p: 1.5, bgcolor: "#f8fafc", borderRadius: 1.5, border: "1px solid #edf2f7" }}>
                      <Box sx={{ display: "flex", justifyContent: "space-between", borderBottom: "1px dashed #e2e8f0", pb: 0.5 }}>
                        <Typography sx={{ fontSize: "12px", color: "#718096", fontWeight: 500 }}>Student Name</Typography>
                        <Typography sx={{ fontWeight: "bold", fontSize: "12px", color: "#1a202c" }}>
                          {studentName.toUpperCase()}
                        </Typography>
                      </Box>
                      <Box sx={{ display: "flex", justifyContent: "space-between", borderBottom: "1px dashed #e2e8f0", pb: 0.5 }}>
                        <Typography sx={{ fontSize: "12px", color: "#718096", fontWeight: 500 }}>Payment Date</Typography>
                        <Typography sx={{ fontWeight: "bold", fontSize: "12px", color: "#1a202c" }}>{formattedDate}</Typography>
                      </Box>
                      <Box sx={{ display: "flex", justifyContent: "space-between", borderBottom: "1px dashed #e2e8f0", pb: 0.5 }}>
                        <Typography sx={{ fontSize: "12px", color: "#718096", fontWeight: 500 }}>Father's name</Typography>
                        <Typography sx={{ fontWeight: "bold", fontSize: "12px", color: "#1a202c" }}>
                          {fatherName.toUpperCase()}
                        </Typography>
                      </Box>
                      <Box sx={{ display: "flex", justifyContent: "space-between", pb: 0.2 }}>
                        <Typography sx={{ fontSize: "12px", color: "#718096", fontWeight: 500 }}>Mother's name</Typography>
                        <Typography sx={{ fontWeight: "bold", fontSize: "12px", color: "#1a202c" }}>
                          {motherName.toUpperCase()}
                        </Typography>
                      </Box>
                    </Box>

                    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.8, p: 1.5, bgcolor: "#f8fafc", borderRadius: 1.5, border: "1px solid #edf2f7" }}>
                      <Box sx={{ display: "flex", justifyContent: "space-between", borderBottom: "1px dashed #e2e8f0", pb: 0.5 }}>
                        <Typography sx={{ fontSize: "12px", color: "#718096", fontWeight: 500 }}>Admission No</Typography>
                        <Typography sx={{ fontWeight: "bold", fontSize: "12px", color: "#1a202c" }}>
                          {admissionNo.toUpperCase()}
                        </Typography>
                      </Box>
                      <Box sx={{ display: "flex", justifyContent: "space-between", borderBottom: "1px dashed #e2e8f0", pb: 0.5 }}>
                        <Typography sx={{ fontSize: "12px", color: "#718096", fontWeight: 500 }}>Receipt No</Typography>
                        <Typography sx={{ fontWeight: "bold", fontSize: "12px", color: "#1a202c" }}>
                          {selectedPayment.transcation_id || selectedPayment.id}
                        </Typography>
                      </Box>
                      <Box sx={{ display: "flex", justifyContent: "space-between", borderBottom: "1px dashed #e2e8f0", pb: 0.5 }}>
                        <Typography sx={{ fontSize: "12px", color: "#718096", fontWeight: 500 }}>Class and Section</Typography>
                        <Typography sx={{ fontWeight: "bold", fontSize: "12px", color: "#1a202c" }}>
                          {classNameVal.toUpperCase()}
                        </Typography>
                      </Box>
                      <Box sx={{ display: "flex", justifyContent: "space-between", pb: 0.2 }}>
                        <Typography sx={{ fontSize: "12px", color: "#718096", fontWeight: 500 }}>Father's Mobile No</Typography>
                        <Typography sx={{ fontWeight: "bold", fontSize: "12px", color: "#1a202c" }}>
                          {fatherMobile}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  {/* Particulars Table */}
                  <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 1.5, borderColor: "#e2e8f0", overflow: "hidden" }}>
                    <Table size="small">
                      <TableHead sx={{ bgcolor: "#3F51B5" }}>
                        <TableRow>
                          <TableCell sx={{ fontWeight: "bold", color: "#ffffff", borderRight: "1px solid rgba(255,255,255,0.2)" }}>
                            Particulars
                          </TableCell>
                          <TableCell align="right" sx={{ fontWeight: "bold", color: "#ffffff", borderRight: "1px solid rgba(255,255,255,0.2)", width: 100 }}>
                            Due
                          </TableCell>
                          <TableCell align="right" sx={{ fontWeight: "bold", color: "#ffffff", width: 100 }}>
                            Paid (Rs)
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow hover>
                          <TableCell sx={{ borderRight: "1px solid #e2e8f0", height: 60, verticalAlign: "top", color: "#2d3748" }}>
                            {selectedPayment.fee_name || 'School Fee'}
                          </TableCell>
                          <TableCell align="right" sx={{ borderRight: "1px solid #e2e8f0", verticalAlign: "top", color: "#2d3748" }}>
                            {amountVal.toFixed(2)}
                          </TableCell>
                          <TableCell align="right" sx={{ verticalAlign: "top", color: "#1a202c", fontWeight: "bold" }}>
                            {amountVal.toFixed(2)}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {/* Total summary row */}
                  <Box
                    sx={{
                      border: "1px solid #3F51B5",
                      borderRadius: 1.5,
                      display: "flex",
                      fontSize: "12px",
                      overflow: "hidden",
                      bgcolor: "#f0f2fa",
                    }}
                  >
                    <Box sx={{ flexGrow: 1, p: 1.2, fontWeight: "bold", color: "#3F51B5" }}>
                      Total Amount in Words : [ Rupees {numberToWords(amountVal)} ]
                    </Box>
                    <Box sx={{ width: 100, p: 1.2, fontWeight: "bold", textAlign: "right", borderLeft: "1px solid #3F51B5", bgcolor: "#3F51B5", color: "#ffffff" }}>
                      Rs.{amountVal.toFixed(2)}
                    </Box>
                  </Box>

                  {/* Note section */}
                  <Box sx={{ fontSize: "10px", mt: 1, display: "flex", flexDirection: "column", gap: 0.4, color: "#718096" }}>
                    <Typography variant="caption" sx={{ fontWeight: "bold", fontSize: "10px", color: "#4a5568" }}>NOTE:</Typography>
                    <Typography variant="caption" sx={{ fontSize: "10px" }}>
                      1.This is a Computer Generated Fee Payment Receipt, 'No Signature' is required.
                    </Typography>
                    <Typography variant="caption" sx={{ fontSize: "10px" }}>
                      2.Parents are advised to keep the receipt securely as it cannot be issued by School,if misplaced.
                    </Typography>
                    <Typography variant="caption" sx={{ fontSize: "10px" }}>
                      3.The fees is subject to Revision as and when advised by the Concerned Authorities and is payable by Parent. The Revision of fees will be notified.
                    </Typography>
                    <Typography variant="caption" sx={{ fontSize: "10px" }}>
                      4.Admission Fee is not Refundable.
                    </Typography>
                  </Box>
                </Box>

                {/* Actions row */}
                <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
                  <Button
                    variant="outlined"
                    fullWidth
                    onClick={() => {
                      setOpenReceipt(false);
                      setSelectedPayment(null);
                    }}
                    sx={{ borderRadius: 999 }}
                  >
                    Close
                  </Button>
                  <Button
                    variant="contained"
                    fullWidth
                    startIcon={<Print />}
                    onClick={() => handlePrint(selectedPayment, studentDetails)}
                    sx={{ borderRadius: 999 }}
                  >
                    Print / Export PDF
                  </Button>
                </Box>
              </Box>
            );
          })()}
        </Box>
      </Modal>
    </Box>
  );
};

export default Payments;
